export const STORE_LOCATOR_MEDIA_CATEGORY = 'ideo/storelocator/category/icon';
export const STORE_LOCATOR_MEDIA_STORE = 'ideo/storelocator/store/icon';
